import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import PageContainer from './PageContainer';
import NewMessageIcon from '../icons/NewMessageIcon';
import NewMessageForm from '../organisms/NewMessageForm';
import MEDIA from '../styles/media';

const useStyles = makeStyles(theme => ({
  messagesPageTemplate: {
    minHeight: '100vh',
  },
  paper: {
    width: '100%',
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  header: {
    padding: 0,
    margin: theme.spacing(5, 5, 0),
    display: 'flex',
    alignItems: 'center',
    ...theme.typography.h2,
  },
  icon: {
    width: '25px',
    height: '25px',
    marginRight: theme.spacing(1),
  },

  [MEDIA.MOBILE]: {
    header: {
      margin: theme.spacing(2),
    },
  },
}), { name: NewMessagePageTemplate.name });

export default function NewMessagePageTemplate () {
  const classes = useStyles();

  return (
    <PageContainer className={classes.messagesPageTemplate}>
      <Paper className={classes.paper}>
        <h1 className={classes.header}>
          <NewMessageIcon className={classes.icon} />
          New Message
        </h1>

        <NewMessageForm />
      </Paper>
    </PageContainer>
  )
}
